import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { selectActiveRoomTab } from "../../../../redux/actions/lobby/actions.js";
import Button from "../../../../core/Button/Button.jsx";
import { roomLeave, closeRoom } from "../../../../redux/actions/rooms/actions.js";
import { useTranslation } from "react-i18next";

function RequestStateButton({ row }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userId = useSelector(state => state.user.id);
    const isMobile = useSelector(state => state.user.isMobile);

    const { table_room_id, table_room_player, table_room_player2 } = row;
    const handleLeaveRoom = () => dispatch(roomLeave({ roomId: table_room_id }));
    const handleCloseRoom = () => dispatch(closeRoom({ roomId: table_room_id }));
    const handleSelectActiveTab = () => dispatch(selectActiveRoomTab({ roomId: table_room_id }));
    const renderButton = () => {
        if (table_room_player2 === userId) {
            return isMobile ? (
                <i className="icon-user-minus" onClick={handleSelectActiveTab} />
            ) : (
                <div className="button-size">
                    <Button
                        onClick={handleLeaveRoom}
                        type={"blue-border"}
                        text={t('buttons.leave')}
                    />
                </div>
            );
        }

        if (table_room_player === userId) {
            return isMobile ? (
                <i className="icon-user-minus" onClick={handleSelectActiveTab} />
            ) : (
                <>
                    <i className="icon-close close-hover" onClick={handleCloseRoom} />
                    <div className="button-size">
                        <Button onClick={handleSelectActiveTab} type={"blue-border"} text={t('buttons.back')} />
                    </div>
                </>
            );
        }

            return isMobile ? (
                <i className="icon-hour-glass" />
            ) : (
                <div className="button-size">
                    <span>{t('buttons.full')}</span>
                </div>
            );

    };

    return <div className="table-buttons-wrapper">{renderButton()}</div>;
}

export default RequestStateButton;
